import React from 'react'
import cn from 'classnames'
import logoAnimated from '../../_static/images/logo-animated.gif'


let Loader = ({className = "", style = {}, isLogoPreloader = false}) => {
    return (
        <div className={cn("preloader", className)} style = {style}>
            <div className={cn("preloader-wrap", {'log-preloader-wrap' : isLogoPreloader})}>
                {
                    isLogoPreloader &&
                    <img src={logoAnimated} alt=""/>
                }
                {
                    !isLogoPreloader &&
                    <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 0 0" space="preserve">
                        <path fill="#00adff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50" transform="rotate(18.4738 50 50)">
                        </path>
                    </svg>
                }
            </div>
        </div>
    )
}

export default Loader


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Loader.js